
export const itemsData = {
  101: [
    {
      id: 1,
      name: "VITAGENE-FORTE [250GM]",
      subTitle: "Validated and Proved technical formulation of vitamin premix fortified with Bio-active Peptides",
      img: "/images/1.png",
      images: [
        "/images/1.png",
        "/images/vitagenvitamin.jpg",

      ],
      composition: `
    - Vitamin A: 13.5 IU
    - Vitamin B1: 1.0 gm
    - Vitamin B2: 6.5 gm
    - Vitamin B6: 1.6 gm
    - Vitamin B12: 30 mg
    - Vitamin D3: 3.5 IU
    - Vitamin E: 9 gm
    - Vitamin K3: 2.0 gm
    - Niacin: 12.0 gm
    - Calcium D Pantothenate: 10.0 gm
    - Folic Acid: 1.0 gm
    - Biotin: 0.05 gm
    - DL-Methionine: QS to fortification and chelation
    - L-Lysine HCl: QS to fortification and chelation
    - Ligand-bound natural bioactive peptides: QS
    - Arginine: 2.05 gm
    - Carrier: QS
  `,
      features: `
  - Specially designed proprietary combination of ligand-bound bioactive natural peptides which act as mediators and enhancers for better absorption and assimilation of both water-soluble and fat-soluble vitamins.
  - Prevents escape of water-soluble and fat-soluble vitamins from the gastrointestinal tract (GIT) and enhances microvilli assimilation efficiency for vitamin and mineral intake with low energy use.
  - Sustained and sequencies release of vitamins. Challenging function for preventing costly vitamin loss it leads to increase the stability and bioavailability of vitamins
  - Prevents the usage of vitamins by microorganisms. Make always readily availability of vitamins for metabolic intake. Prevents overages of vitamin usage during formulation and teed preparation.
`,

      dosage: "500 gms per ton of feed.",
      disclaimer: "The dosage and usage should be as advised by a consultant veterinarian."
    },
    {
      id: 2,
      name: "THERAMIN-FORTE (Chelated Trace Minerals)",
      img: "/images/3.png",
      subTitle:
        "A Complete and balanced Trace Mineral composition fortified with ligand binding Amino acids and Bio active peptides, Highly Bio-available Organic Trace Minerals",
      composition: `
    Each 1 kg contains:
    - Manganese: 80 g
    - Zinc: 80 g
    - Iron: 60 g
    - Copper: 15 g
    - Iodine: 1.0 g
    - Selenium: 300 mg
    - Ligand-bound amino acids: 3.2 g
    - Bioactive peptides: 120 mg
  `,

      features: `
Trace Mineral Benefits: Research shows that supplementing poultry birds with highly bioavailable trace minerals offers numerous benefits including

    In Broilers:
    • Reduces skin scratches and cellulitis.
    • Enhances breast meat yield and growth rates.
    • Improves foot pad quality improved immunity.
    

    In Layers:
    • Increases egg production and improves egg/eggshell quality.
    • Improves feed-to-egg ratio and reduces hen mortality.
    • Good  chick quality and hatchability Enhanced immunity.
    
  `,

      dosage: `
    - Regular use: 1 kg per ton of feed.
   
  `,

      disclaimer:
        "The dosage and usage should always be followed as advised by a qualified veterinary consultant."
    },

    {
      id: 3,
      name: "GENETOX-B (Toxin Binder)",
      img: "/images/4.png",
      images: ["/images/4.png", "/images/genetox.png"],
      subTitle:
        "Technically proved toxin binder to inactivate and reduce the bio-availability of all types of Micro-toxins.",

      composition: `
    - HSCAS (Hydrated Sodium Calcium Alumino-silicate)
    - PVPP (Cross-linked, insoluble Polyvinylpyrrolidone homopolymer)
    - MOS (Mannan oligosaccharides)
    - Organic acids (mould inhibitors)
    - Activated charcoal
    - Probiotic strains
  `,

      features: `
    - Prevention is better than therapy | Technically proved and effectively acting toxin binder which protect poultry flock from mycosis disease Binds to all types of toxins based on their polarity and net charge, finally decontaminate them Inactivate toxins, Improves the nutrient intake and absorption. Protect Intestinal tract.
    - Contains Potential absorbent materials such as activated carbon (Inactive deoxynivalenol and nivanenol), allumino silicates, earth minerals. Aflatoxin. selective HSCAS inactive ochratoxin, sterigmatocystin.
    - Complex indigestible carbohydrates such as cellulose, mannan oligosaccharides and peptides glycans Inactivate T-2 toxin, Zearalenone 
    - toxin Synthetic polymer’s such as PVPP inactivate aflatoxin and Zearalenone. Organic Acids Inactivate most of the mycotoxins | Probiotic strains such as lactic acid bacteria, proploni bacteria
	    and bifido bacteria effectively inactive the fusarium produced mycotoxins.
  `,

      dosage: `
    - Preventive: 500 g per ton of feed (0.5 kg/ton).
    - For high moisture or higher contamination risk: 1–2 kg per ton of feed.
  `,

      disclaimer:
        "Dosage and usage should be followed as advised by a qualified veterinary consultant."
    },
    {
      id: 4,
      name: "LIVERSOL-FS",
      img: "/images/7.png",
      images: ["/images/7.png", "/images/liver.jpg"],
      subTitle:
        "A complete solution to prevent and cure liver disorders in broilers and layers.",

      composition: `
    Each 500 g contains:
    - Choline Chloride – Supports fat metabolism & prevents fatty liver
    - Silymarin – Natural hepatoprotective, repairs liver cells
    - Biotin – Enhances metabolic activity
    - Vitamin B12 – Improves blood formation & energy utilization
    - Methionine – Essential amino acid, reduces liver stress
    - Inositol – Improves liver detoxification & bile secretion
    - Protein hydrolysate – 120 mg
    - Biomolecule blend – QS
    - Stabilizer – QS
    - Carrier – QS
  `,

      features: `
    - Specially designed bio-active herbals and biomolecules prevent and cure all types of liver disorders in broilers and layers.
    - Protects the liver from mycotoxins, endotoxins, chemical toxins, pathogenic microbes, and environmental stress.
    - Proprietary biomolecules enhance liver cell metabolism and protect against pathogenic microbes.
    - Prevents excess fat deposition in the liver due to improper metabolism.
    - Neutralizes mycotoxins and stimulates liver function.
    - Enhances liver secretions to maintain healthy digestion and mobilize unwanted molecules deposited in the liver.
    - Plays a key role in rejuvenation of damaged liver cells.
    - Stimulates appetite depressed due to toxins.
    - Minimizes liver damage and enhances hepatokidney functions.
    - Improves growth, feed conversion ratio (FCR), fertility, and hatchability.
  `,

      dosage: "Use 500 g to 1 kg of Liversol-FS per ton of feed.",

      disclaimer:
        "The dosage and usage should be advised by the consultant veterinarian."
    },

    {
      id: 5,
      name: "ACID-BUFFER",
      img: "/images/8.png",
      images: ["/images/8.png", "/images/acid.png"],

      subTitle:
        "ACIDIFIRES WITH BUFFERING AGENTS Blend of organic acids and buffering agents for healthy gut",

      composition: `
    Each 1 kg contains:
    - Formic Acid ≥ 11.4%
    - Benzoic Acid ≥ 10.5%
    - Phosphoric Acid ≥ 3%
    - Butyric Acid ≥ 5.5%
    - Propionic Acid ≥ 7.6%
    - Sodium Benzoate ≥ 6%
    - Sorbic Acid ≥ 5%
    - Citric Acid ≥ 9%
    - L-Lactic Acid ≥ 6%
    - Acetic Acid ≥ 6%
    - Buffering agents Qs
  `,

      features: `
    - Contains a blend of organic acids and their salts, buffering agents, and organic acid–secreting probiotic strains of normal gut flora.
    - Organic acids maintain the acidic environment of the digestive system (stomach, crop, duodenum, etc.) in poultry birds, segment-wise equilibrating H⁺ ion concentration.  
    - Buffering agents help sustain the acidic pH for a longer duration.
    - Organic acid–secreting probiotic microbes release natural acids to rebalance pH if ion disassociation occurs.  
    - Maintain GUT pH and favours the digestion process Natural organic acids maintains the pH of GUT for the better action of digestive enzymes which works at acidic pH.
    - Prevents the growth of pathogenic micro-organisms Organic acid secreting probiotic strains acts as probiotic normal flora in the intestinal tract | Avoid the colonization and biofilm formation.
    - Improvement in daily growth, FCR. Favours the absorption of minerals, drug active ingredients | Also used as water acidifier and controls general mortality.
  `,
      dosage: "1 kg to 2.5 kg per ton of feed.",
      disclaimer:
        "The dosage and usage should be advised by the consultant veterinarian."
    }
    ,

    {
      id: 6,
      name: "CAL-D-GENE (Blend of Calcium, Vitamin D3 & Vitamin B12)",
      img: "/images/9.png",
      images: ["/images/9.png", "/images/caldgene.png"],
      subTitle:
        "Controls Calcium Deficiency & Improve Egg shell Quality",

      composition: `
     Each 500 g contains:
    - Calcium lactate: 1500 mg
    - Phosphorous: 460 mg
    - Vitamin D3: 950 IU
    - Vitamin B12: 8.35 µg
    - Cobalt: 5 mg
    - Elemental iron: 15 mg
    - Bioactive peptides: QS
    - Preservatives: QS
    - DDW: QS
  `,

      features: `
    - Efficient research output contains calcium lactate, vitamins, minerals, and bioactive peptides. Enhances the metabolism of bones, skeletal system, and shell formation. Improves mineral, vitamin, and nutrient absorption.
    - Prevents the formation of thin shell eggs, nutrient loss, and fluctuations in production. Prevents osteoporosis and osteomalacia.
    - Avoids leg weakness, macrocytic anemia, and hypocalcemia. Improves weight gain in broilers, egg quality in layers, and helps prevent cannibalism in birds.
  `,

      dosage: "500 grams to 1 kg per ton of feed.",
      disclaimer:
        "The dosage and usage should be advised by the consultant veterinarian."
    },

  ],
  102: [
    {
      id: 7,
      name: "METHIOGENE",
      img: "/images/16.png",
      subTitle:
        "DL – METHIONINE – 98.9% pure",
      features: `
    - Molecular Formula: C5H11N2S
    - Alternate Names: Methylthio Butyric Acid
    - Appearance: Light yellow, sulfur-containing powder
    - Nutritional Role: First limiting amino acid in poultry feed
    - Unique Point: Only sulfur-containing amino acid, essential for keratin and collagen formation
    - Special Function: Lipotropic agent, prevents fatty liver syndrome
  `,
      functions: `
    1. Protein Synthesis & Growth – Provides sulfur for body proteins, supports muscle and tissue growth.
    2. Feather Development – Critical for keratin; ensures smooth feathering and reduced energy loss.
    3. Methyl Donor Role – Through SAM (S-Adenosylmethionine), regulates DNA/RNA methylation, gene expression, and liver function.
    4. Immune Support – Enhances antibody production, strengthens disease resistance.
    5. Antioxidant Role – Precursor of cysteine and glutathione, key in detoxification and oxidative stress control.
    6. Egg Production – Improves egg mass, albumen quality, and eggshell strength.
    7. Fat Metabolism – Prevents excessive fat deposition in liver; improves lipid transport.
    8. Feed Efficiency – Reduces need for excess protein → lowers nitrogen excretion, making feeding cost-effective & eco-friendly.
  `,
      benefits: `
    - Promotes rapid growth & better feed conversion.
    - Enhances feather quality & plumage.
    - Supports immune health and stress resistance.
    - Boosts egg production & quality.
    - Protects liver health and improves fat utilization.
    - Environment-friendly → reduces nitrogen waste.
  `,
      dosage: `
    500 g – 1 kg per ton of feed
    (or as per veterinarian’s advice depending on bird type & growth stage).
  `,
      disclaimer:
        "The dosage and usage should be as advised by a consultant veterinarian.",
      productOverview: `
    Methionine is an essential sulfur-containing amino acid and one of the first limiting amino acids in poultry diets, especially in corn–soybean meal-based feeds. Birds cannot synthesize methionine in sufficient amounts, so it must be supplied through the diet.
  `
    },


    {
      id: 8,
      name: "LYSINE-G",
      img: "/images/17.png",
      subTitle:
        "Lysine Hydrochloride – 98.6% pure",
      productOverview: `
    Lysine is one of the most important essential amino acids in poultry nutrition. It plays a critical role in protein synthesis, muscle growth, feather development, and overall performance of birds. As poultry cannot synthesize Lysine on their own, it must be provided through feed supplementation to ensure optimal growth and productivity.
  `,
      features: `
    - Molecular Formula: C₆H₁₄N₂O₂
    - Alternate Names: Diaminohexanoic Acid, Alpha Sigma Diaminocaproic Acid
    - Appearance: White or light-yellow granular form
    - Bulk Density: 0.5 – 0.6 gm/cm³
  `,
      functions: `
    1. Muscle Growth & Protein Synthesis
       - Building block of body proteins.
       - Directly influences breast meat yield in broilers.
    2. Feather Development
       - Essential for keratin formation, improving feathering and plumage quality.
    3. Immune Function
       - Supports antibody formation and boosts disease resistance.
       - Aids in enzyme & hormone synthesis for immune regulation.
    4. Collagen & Bone Development
       - Crucial for collagen formation, bone growth, tissue repair, and skin integrity.
    5. Reproductive Performance
       - Enhances egg production, egg size, and hatchability in layers and breeders.
    6. Nutrient Utilization & Feed Efficiency
       - Improves FCR (Feed Conversion Ratio).
       - Reduces nitrogen excretion → environmentally friendly.
    7. Limiting Amino Acid Role
       - First limiting amino acid in cereal–soybean diets.
       - Deficiency restricts growth even if other amino acids are sufficient.
  `,
      benefits: `
    - Promotes protein synthesis and muscle growth.
    - Improves feather development and overall bird health.
    - Boosts immune function.
    - Enhances egg size, mass, and production.
  `,
      dosage: `
    500 g – 1 kg per ton of feed
    (or as advised by a qualified veterinarian).
  `,
      disclaimer:
        "The dosage and usage should be as advised by a consultant veterinarian."
    },


    {
      id: 9,
      name: "L-THREOGENE",
      img: "/images/18.png",
      subTitle:
        "L–Threonine Essential Amino Acid – Feed Grade",
      productOverview: `
    L-Threonine is the third limiting amino acid in poultry diets (after Methionine and Lysine), especially in corn–soybean-based rations. It is essential for protein balance, growth, gut health, and immune function in poultry. Birds cannot synthesize it naturally, so supplementation is necessary for optimal performance.
  `,
      features: `
    - Molecular Formula: C₄H₉NO₃
    - Alternate Names: 2-Amino-3-hydroxybutyric acid
    - Appearance: White crystalline powder
    - Solubility: Freely soluble in water
    - Nutritional Role: Essential for balanced protein synthesis & metabolism
  `,
      functions: `
    1. Protein Synthesis & Growth
       - Maintains balanced amino acid profile.
       - Promotes lean muscle growth & weight gain.
    2. Gut Health & Digestion
       - Major component of intestinal mucin (protects gut lining).
       - Improves nutrient absorption & feed utilization.
    3. Immune Function
       - Enhances antibody production & disease resistance.
       - Supports stress tolerance in poultry flocks.
    4. Feather Development
       - Contributes to keratin synthesis → healthy plumage.
    5. Egg Production & Reproduction
       - Improves egg size, quality, and hatchability in breeders.
    6. Nitrogen Utilization & Eco-Friendliness
       - Prevents excess nitrogen excretion.
       - Reduces need for high crude protein diets → cost-effective & environmentally friendly.
  `,
      benefits: `
    - Improves growth performance & FCR (Feed Conversion Ratio).
    - Maintains gut health & digestive efficiency.
    - Boosts immunity & disease resistance.
    - Enhances feathering & reproductive performance.
    - Reduces feed cost by lowering crude protein levels.
  `,
      dosage: `
    300 g – 800 g per ton of feed
    (or as per veterinarian/nutritionist recommendation)
  `,
      disclaimer:
        "The dosage and usage should be as advised by a consultant veterinarian."
    }

  ],
  103: [
    {
      id: 10,
      name: "GEN-CTC - 15%",
      img: "/images/2.png",
      images: ["/images/2.png", "/images/ctc.jpg"],
      subTitle: "Granular Chlortetracycline 15%  Feed Grade",
      composition: "Each 1 kg contains 150 gm of Chlortetracycline - 15%",
      features: `
    - Chlortetracycline is a broad-spectrum antibiotic, effective against most Gram-positive and Gram-negative bacteria.
  `,
      mechanismOfAction: `
    - Chlortetracycline is bacteriostatic at sub-therapeutic and therapeutic levels; in higher concentrations may be bactericidal.
    - The method of action is through interference with protein synthesis of bacteria.
  `,
      benefits: `
    - Growth promotion, prevention of stress, improvement in egg production.
    - Improvement in weight gain and general health.
    - To maintain health and to prevent Mycoplasma in poultry.
    - Helps in prevention of early chick mortality.
  `,
      dosage: `
    - Add 500 gm to 1 kg of CTC-15% per ton of feed.
    - Or as directed by the veterinarian.
  `,
      disclaimer: "The dosage and usage is advised by the consultant veterinarian."
    },

    {
      id: 11,
      name: "TYLOGEN-10%",
      img: "/images/19.png",
      images: ["/images/19.png", "/images/tylodex.png"],
      subTitle: "Tylosin phosphate 10% feed supplement",
      composition: `
    Each Kg contains Tylosin phosphate: 100gms.
  `,
      features: `
    - Tylosin phosphate has a broad-spectrum antibiotic effect, effective against most Gram-positive and Gram-negative bacteria, and is highly active against Mycoplasma.
  `,
      benefits: `
    - Improves FCR.
    - Prevention and control of Mycoplasma infections.
    - Prevents problems like CRD caused by contagious pathogenic environment.
    - Increases egg production and body weight.
    - Improves resistance.
    - Fast action and effective formulation as a preventive measure.
  `,
      dosage: `
    - Broilers & Layers: 500 gm – 1 kg per Ton of feed.
   
  `,
      disclaimer: "The dosage and usage should be as advised by a consultant veterinarian."
    }
    ,

    {
      id: 12,
      name: "GENMULIN-10%",
      img: "/images/20.jpeg",
      subTitle: "Tiamulin Hydrogen Fumarate 10% Feed Premix Granules",
      composition: `
    • Each 1 Kg contains Tiamulin Hydrogen Fumarate 10%.
    • Fermentation Origin.
  `,
      mechanismOfAction: `
    • Tiamulin exerts its antibacterial effect by inhibiting bacterial protein synthesis.
    • Tiamulin is primarily effective against Gram-positive bacteria and some Gram-negative anaerobes, as well as Mycoplasma spp., which are significant in poultry diseases.
  `,
      benefits: `
    • Tiamulin is a specific activity against Mycoplasma; it prevents Mycoplasma gallisepticum and Mycoplasma synoviae for chronic respiratory disease caused by Mycoplasma gallisepticum.
    • It is active against Gram-positive bacteria, Mycoplasma & anaerobes.
    • Highly active granules with free-flow ability.
    • Easy mixing with feed and fast release.
    • Qualitative and quantitative composition.
    • Improves feed efficiency.
    • Improved body weight.
  `,
      dosage: `
    • Broilers & Layers: 500 gm to 1 kg per ton of feed.
    • As directed by the veterinarian or consultant.
  `,
      disclaimer: "Use under veterinary guidance for optimal results."
    },

    {
      id: 13,
      name: "GENTRIM-FS",
      img: "/images/22.png",
      subTitle: "Trimethoprim and sulphamethoxazole powder",
      composition: `
    • Sulphamethoxazole: 100mg per gram
    • Trimethoprim: 20mg per gram
  `,
      features: `
    • GENTRIM-FS is an antimicrobial combination to treat a wide range of bacterial and protozoal infections.
    • The synergistic action of the two drugs makes them highly effective against pathogens that cause respiratory, enteric, and other systemic illnesses.
  `,
      benefits: `
    • Controls Infectious Coryza, Enteritis, White Diarrhoea.
    • Controls Coli Septicaemia, Coccidiosis, with mixed bacterial infections.
    • Controls early chick mortality and secondary bacterial infections.
  `,
      dosage: `
    • 500gm – 1kg per ton of feed.
  `,

      disclaimer: "The dosage and usage should be as advised by a consultant veterinarian."
    },


    {
      id: 14,
      name: "GENMULIN-80%",
      img: "/images/62.png",
      subTitle: "Tiamulin Hydrogen fumarate 80% Feed Premix",
      composition: `
    • Each 1 gram contains Tiamulin Hydrogen Fumarate 80%.
    • Fermentation Origin.
  `,
      mechanismOfAction: `
    • Tiamulin exerts its antibacterial effect by inhibiting bacterial protein synthesis.
    • Tiamulin is primarily effective against Gram-positive bacteria and some Gram-negative anaerobes, as well as Mycoplasma spp., which are significant in poultry diseases.
  `,
      features: `
    • Tiamulin has specific activity against Mycoplasma; prevents Mycoplasma gallisepticum and Mycoplasma synoviae for chronic respiratory disease.
    • Active against Gram-positive bacteria, Mycoplasma, and anaerobes.
    • Highly active granules with free flow ability.
    • Easy mixing with feed and fast release.
    • Qualitative and quantitative composition.
    • Improves feed efficiency.
    • Improves body weight.
  `,
      dosage: `
    • Broilers & Layers: 250g – 500g per ton of feed.
    • Or as directed by the veterinarian/consultant.
  `,
      disclaimer: "Use under veterinary guidance for optimal results."
    },

    {
      id: 15,
      name: "GEN-OTC 20%",
      img: "/images/64.png",
      subTitle: "Granular Oxy Tetracycline 20% Feed Supplement",
      composition: `
    • Each 1 Kg Contains 200gms of Oxy Tetracycline.
  `,
      mechanismOfAction: `
    • Oxytetracycline is broad-spectrum, bacteriostatic at sub-therapeutic and therapeutic levels, but in higher concentrations may be bactericidal.
    • The mode of action is through interference with protein synthesis.
  `,
      benefits: `
    • Improves feed efficiency during stress.
    • Reduces early chick mortality.
    • Prevents diseases like Fowl Cholera, CRD, etc.
  `,
      dosage: `
    • Broilers & Layers: 500 gm to 1 kg per ton of feed.
    • As directed by the veterinarian or consultant.
  `,
      disclaimer: "Use under veterinary guidance for optimal results."
    },


    {
      id: 16,
      name: "ENRAMYCIN-10%",
      img: "/images/47.jpeg",
      subTitle: "Enramycin 10% Feed Supplement)",
      productOverview: `GENE Enramycin 10% is a potent antimicrobial feed additive containing     Enramycin – 10%, developed to improve growth performance and gut health in poultry and livestock. It effectively controls harmful gram-positive bacteria in the gastrointestinal tract and supports better nutrient utilization, leading to enhanced productivity.`,
      composition: `
    • Active Ingredient: Enramycin – 10%
  `,
      features: `
    • Broad-spectrum antibacterial activity, especially against Clostridium spp.
    • Improves feed efficiency and growth rate in poultry and swine.
    • Reduces incidence of necrotic enteritis and other gut-related disorders.
  `,
      benefits: `
    • Prevention and control of necrotic enteritis in poultry.
    • Improves body weight gain and feed conversion ratio (FCR).
    • Supports gut health and performance in broilers, layers, breeders, and swine.
  `,
      dosage: `
    • Poultry: 100–200 g per ton of feed (depending on age and production stage).
    • Swine: 100–150 g per ton of feed.
    • Or advised by the consultant for the veterinarian recommendation.
  `,
      disclaimer: "Use under veterinary guidance for optimal results."
    },

    {
      id: 17,
      name: "FURAGENE-20%",
      img: "/images/48.jpeg",
      subTitle: "Furazolidone – 20% Feed Supplement",
      productOverview: `Furagene-20% is a high-quality feed supplement containing each gram Furazolidone (20%), widely used in poultry and livestock nutrition. It plays a crucial role in maintaining gut health, improving feed efficiency, and supporting growth performance by controlling harmful intestinal pathogens.`,

      features: `
    • Broad-spectrum action against bacterial and protozoal infections.
    • Helps in prevention and control of enteric diseases in poultry and livestock.
    • Improves feed conversion ratio (FCR) and promotes uniform growth.
    • Enhances nutrient absorption and supports overall performance.
    • Ensures better liveability and productivity in farm animals.
  `,
      indications: `
    • Bacterial enteritis
    • Diarrhea of bacterial origin
    • Dysentery and gastrointestinal disturbances
    • Growth promotion and feed efficiency improvement
  `,
      dosage: `
    • Poultry: 100–200 g per ton of feed (or as directed by a veterinarian)
    • Livestock: 5–10 mg/kg body weight in feed or water
    • Or as advised by the consultant for the veterinarian recommendation
  `,
      disclaimer: "Use under veterinary guidance for optimal results."
    },

    {
      id: 18,
      name: "GENE BMD 10%",
      img: "/images/23.png",
      subTitle: "BACITRACIN METHYLENE DISALICYLATE (BMD)- 10%)",
      productOverview: `
    GENE BMD 10% is a highly effective feed additive containing Bacitracin Methylene Disalicylate (BMD) – 10%, designed to support optimal gut health and improve growth performance in poultry and livestock. It acts as a reliable antibacterial feed supplement that helps control harmful gram-positive bacteria in the gastrointestinal tract.
  `,
      composition: `
    • Active Ingredient: Bacitracin Methylene Disalicylate (BMD) – 10%
  `,
      features: `
    • Broad-spectrum activity against Clostridium spp., Streptococcus spp., and Staphylococcus spp.
    • Enhances feed conversion ratio (FCR) and growth rate.
    • Promotes gut health by reducing pathogenic bacterial load.
    • Improves weight gain and productivity in poultry and livestock.
    • Stable in feed with no cross-resistance with other commonly used antibiotics.
  `,
      benefits: `
    • Prevention and control of necrotic enteritis in poultry.
    • Improves growth performance and feed efficiency in broilers, layers, and breeders.
    • Effective in controlling bacterial enteritis in swine and cattle.
    • Supports gut integrity and nutrient absorption to improve feed efficiency during stress.
    • Reduces early chick and hen mortality.
  `,
      dosage: `
    • Each 500 gm to 1 kg per ton of feed based on conditions.
    • Or as advised by the consultant veterinarian.
  `,
      disclaimer: "The dosage and usage should be as advised by a consultant veterinarian."
    }


  ],
  104: [
    {
      id: 19,
      name: "VITASOL-L",
      img: "/images/25.png",
      images: ["/images/25.png", "/images/vitasol.jpg"],
      subTitle:
        "Validated and proven technical formulation of Vitamin Premix fortified with Bio-active Peptides.",
      composition: `
    Each 5ml Vitasol contains:
    - Vitamin A: 250,000 IU
    - Vitamin D3: 30,000 IU
    - Vitamin E: 150 IU
    - Vitamin C: 500 mg
    - Vitamin B12: 100 mcg
    - Ligand bound Bioactive peptides – QS
  `,
      features: `
    - Specially designed proprietary combination of ligand bound bioactive natural peptides which acts as mediators and enhancers for better absorption and assimilation of both water-soluble and fat-soluble vitamins.
    - Prevents escape of water-soluble and fat-soluble vitamins from GIT. Enhances microvilli assimilation power for vitamin and mineral intake with low energy use.
    - Sustained and sequential release of vitamins, preventing costly vitamin loss, increasing stability and bioavailability.
  `,
      dosage: `
    - Chicks: 5ml per 100 chicks per day
    - Layers, Growers, Broilers: 5–10ml per 100 birds per day
  `,
      disclaimer: "The dosage and usage as advised by the consultant veterinarian."
    },
    {
      id: 20,
      name: "CAL-D-GENE - LIQ",
      img: "/images/29.png",
      subTitle:
        "Controls Calcium Deficiency & Improves Egg shell quality in Layers.",
      composition: `
    Each 10 ml Contains:
    - Calcium lactate: 512 mg
    - Phosphorous: 460 mg
    - Vitamin B12: 8.35 µg
    - Elemental iron: 15 mg
    - Vitamin D3: 950 IU
    - Cobalt: 5 mg
    - Preservatives: QS (Quantity sufficient)
    - DDW: QS (Quantity sufficient)
    - Bioactive peptides: QS (Quantity sufficient)
  `,
      features: `
    - Efficient research output contains calcium lactate, vitamins, minerals, and bioactive peptides.
    - Enhances the metabolism of bone, skeletal system, and shell formation.
    - Improves mineral, vitamin, and nutrient absorption.
  `,
      benefits: `
    - Prevents the formation of thin shell eggs and nutrient loss.
    - Avoids fluctuations in production; prevents osteoporosis and osteomalacia.
    - Prevents leg weakness, macrocytic anaemia, and hypocalcaemia.
    - Improves weight gain in broilers and egg quality in layers.
    - Avoids cannibalism in birds.
  `,
      dosage: `
    - Chick / Grower: 10 ml per 100 birds.
    - Layer / Broilers: 15–20 ml per 100 birds.
  `,
      disclaimer: "The dosage and usage as advised by the consultant veterinarian."
    },

    {
      id: 21,
      name: "LIVERSOL-L",
      img: "/images/24.png",
      subTitle:
        "A complete solution and cure for liver disorders in broilers and layers.",
      composition: `
    - Tricholine Citrate – 1000mg (Tricholine citrate is a hepatoprotective agent)
    - Choline Chloride – QS (Supports fat metabolism & prevents fatty liver)
    - Silymarin – QS (Natural hepatoprotective, repairs liver cells)
    - Biotin – QS (Enhances metabolic activity)
    - Vitamin B12 – 20 mcg (Improves blood formation & energy utilization)
    - Methionine – 40mg (Essential amino acid, reduces liver stress)
    - Inositol – 20mg (Improves liver detoxification & bile secretion)
    - Protein hydrolysate – 120mg, Stabilizer-QS
    - Biomolecule blend – QS, Carrier-QS
  `,
      features: `
    - Contains specially designed bio-active herbals and bio molecules which prevents and cure all types of liver disorders in broiler and layers.
    - Mostly liver effected by mycotoxins, endotoxins, chemical toxins in feed, environmental factors, pathogenic microbes and feed conservation efficiency of poultry flock.
    - Proprietary bio molecules protect the liver from pathogenic microbes and enhance the liver cell metabolism.
    - Prevents the deposition of excess fat in liver due to improper metabolism in liver cell and GIT
    - Protect the liver from all types of mycotoxins by neuralization and stimulates the liver function.
    - Enhance the liver secretions to maintain the healthy digestion and enhance the mobilization of unwanted molecules deposited in liver.
    - Perform a key role in rejuvenation of damaged liver cells properly and effectively.
  `,
      dosage: `
    - Use 10-20ml of Liversol liquid per 100 birds.
  `,
      disclaimer: "The dosage and usage is advised by the consultant veterinarian."
    },

    {
      id: 22,
      name: "ACID BUFFER - LIQ",
      img: "/images/28.png",
      subTitle: "Blend of Organic Acids & Buffering Agents for healthy Gut",
      composition: `
    - Lactic Acid – Promotes beneficial gut microflora
    - Citric Acid – Improves digestion & nutrient absorption
    - Acetic Acid – Controls the GUT acidification
    - Butyric Acid – Antimicrobial Properties
    - Propionic Acid – Prevents mold & bacterial growth in feed/water
    - Formic Acid – Controls harmful gut pathogens
    - Buffering Agents – Digestive enzyme secreting/segregating microbes or additives
  `,
      features: `
    - Contains a blend of organic acids and their salts, buffering agents, organic acid secreting probiotic strains of normal flora.
    - Organic acids maintain the acidic pH of digestive system (stomach, crop onward part, duodenum etc) of poultry birds.
    - Buffering agents maintain the acidic pH for long time.
    - Organic acid–secreting probiotic microbes release natural organic acids that help maintain gut pH equilibrium by balancing ion dissociation.
    - Natural organic acids maintain the pH of GUT for the better action of digestive enzymes which works of acidic pH.
  `,
      benefits: `
    - Maintains optimum gut pH for better digestion.
    - Controls Salmonella, E. coli, and Clostridia infections.
    - Improves feed conversion ratio (FCR) & weight gain.
    - Reduces diarrhea, wet droppings & gut stress.
    - Enhances nutrient absorption & growth performance.
    - Prevents mold growth in feed & water systems.
  `,
      dosage: `
    - Layers/Breeders: 10–15 ml per 100 birds daily
    - During gut infections/stress: Double the recommended dose for 3–5 days
  `,
      disclaimer: "The dosage and usage is advised by the consultant veterinarian."
    },

    {
      id: 23,
      name: "GROWWIN-LIQ",
      img: "/images/26.png",
      subTitle: "Specially Formulated Growth Enhancing Components for Weight Gain to win Better Profits",
      composition: `
    - Essential Amino Acids (Methionine, Lysine, Threonine) – For muscle development & protein synthesis
    - Probiotics & Enzymes – Improve digestion & nutrient utilization
    - Vitamins (B-Complex, D3, E) – Enhance metabolism & immunity
    - Trace Minerals (Zinc, Iron, Manganese, Selenium) – Support growth, bone health & feed efficiency
    - Herbal Growth Promoters – Stimulate appetite & gut health
  `,
      productOverview: `	Specially designed formulae contains a blend of growth enhancing components called class A&B (vitamins-A,B2,D3 ,E,K,B1,B6,B12,Bioactive peptides, Ligands, amino acids, Prebiotics, probiotics, Immunity Boosters, Enzymes ,Chelated Trace Minerals( fortified with peptides.`,

      benefits: `
    - Accelerates weight gain and improves feed conversion ratio (FCR).
    - Enhances protein & energy utilization from feed.
    - Boosts immunity, stamina & liveability.
    - Reduces stress impact during vaccination, heat & transport.
    - Increases profitability with faster growth & higher body weight.
    - Probiotics maintain gut pH and equilibrate the normal flora of gut, enhancing energy metabolism.
    - Amino acid ligands equilibrate the mineral and vitamin absorption, assimilation, and protein metabolism.
  `,
      dosage: `
    - 5ml to 10ml per 100 birds in drinking water.
    - Usage as advised by the consultant veterinarian.
  `,
      disclaimer: "The dosage and usage is advised by the consultant veterinarian."
    },

    {
      id: 24,
      name: "IMMUN PRO - Liq",
      img: "/images/27.png",
      subTitle: "Research-based Unique Product for Better Immunity in Poultry",
      productOverview: "IMMUN PRO is a research-based unique formulation designed to strengthen the immune system and improve overall poultry health.",
      composition: `
    - Vitamin E – 250 mg
    - Selenium – 1.5 mg
    - Biotin – 2.5 mg
    - Bioactive Peptides – 2.5 mg
    - Natural Probiotic Strains – QS
  `,

      benefits: `
    - Boosts immunity: Vitamin E and Selenium reduce oxidative stress and improve resistance against infections.
    - Gut health support: Probiotics balance intestinal microflora, aiding digestion and nutrient utilization.
    - Growth & performance: Bioactive peptides promote protein synthesis and better feed efficiency.
    - Feather & skin care: Biotin improves feather quality and prevents dermatitis.
    - Stress protection: Helps birds cope with stress from vaccination, climate changes, and high stocking density.
    - Flock productivity: Reduces mortality and enhances livability.
  `,
      dosage: `
    - 5ml to 10ml per 100 birds in drinking water.
  `,
      disclaimer: "The dosage and usage is advised by the consultant veterinarian."
    },
  ],


  105: [
    {
      id: 25,
      name: "LEVOGEN BH-20%",
      img: "/images/32.png",
      subTitle:
        "Levofloxacin & Bromhexine Hydrochloride Oral Solution",
      composition: `
    - Levofloxacin Hemihydrate IP (equivalent to Levofloxacin) – 100 mg/ml
    - Bromhexine Hydrochloride IP – 15 mg/ml
  `,
      productOverview: `
    LEVOGEN BH-20% is a broad-spectrum antimicrobial oral solution, fortified with a mucolytic agent.
    • Levofloxacin: A fluoroquinolone antibiotic effective against Gram-positive & Gram-negative bacteria, including E. coli, Mycoplasma, Salmonella, Pasteurella.
    • Bromhexine Hydrochloride: A mucolytic that reduces mucus viscosity, enhances penetration of antibiotics into respiratory secretions, and improves respiratory efficiency.
  `,
      indications: `
    - Chronic & acute respiratory infections in poultry.
    - CRD (Chronic Respiratory Disease) due to Mycoplasma gallisepticum and E. coli.
    - Colibacillosis, Salmonellosis, Pasteurellosis.
    - Secondary bacterial infections in viral respiratory diseases.
    - Improves mucus clearance and antibiotic activity in the lungs.
  `,
      benefits: `
    - Strong broad-spectrum antibacterial action.
    - Synergistic effect: Bromhexine increases lung penetration of Levofloxacin.
    - Relieves respiratory distress by reducing mucus congestion.
    - Rapid recovery, reduced mortality & improved productivity.
  `,
      dosage: `
    Poultry (Broilers, Layers, Breeders):
    - 1 ml per 5–10 kg body weight in drinking water, once daily for 3–5 days.
    - Or as directed by a veterinarian.
  `,
      disclaimer:
        "The dosage and usage should be strictly as advised by a consultant veterinarian."
    },

    {
      id: 26,
      name: "ENROGEN BH-20%",
      img: "/images/33.png",
      subTitle:
        "Enrofloxacin & Bromhexine Hydrochloride Oral Solution",
      composition: `
    - Enrofloxacin IP – 200 mg/ml
    - Bromhexine Hydrochloride IP – 15 mg/ml
  `,
      productOverview: `
    ENROGEN BH-20% is a powerful combination of a broad-spectrum fluoroquinolone antibiotic with a mucolytic agent.
    • Enrofloxacin: Highly effective against Gram-negative and Gram-positive bacteria, including E. coli, Salmonella, Pasteurella, Mycoplasma, Haemophilus, Staphylococcus.
    • Bromhexine Hydrochloride: Reduces viscosity of mucus, improves clearance of respiratory secretions, and enhances antibiotic penetration into lung tissues.
  `,
      indications: `
    - CRD (Chronic Respiratory Disease) caused by Mycoplasma gallisepticum and secondary E. coli.
    - Colibacillosis, Salmonellosis, Pasteurellosis.
    - Mixed respiratory infections with heavy mucus exudation.
    - Supportive therapy during viral respiratory infections (to prevent secondary bacterial complications).
  `,
      benefits: `
    - Broad-spectrum antibacterial with high tissue penetration.
    - Synergistic effect: Bromhexine enhances antibiotic activity in the respiratory tract.
    - Rapid clearance of mucus → improved breathing & feed intake.
    - Promotes faster recovery, reduced mortality, and better flock performance.
  `,
      dosage: `
    Poultry (Broilers, Layers, Breeders):
    - 1 ml per 10–15 kg body weight in drinking water, once daily for 3–5 days.
    - Or as directed by a veterinarian.
  `,
      disclaimer:
        "The dosage and usage should be strictly as advised by a consultant veterinarian."
    }
    ,
    {
      id: 27,
      name: "ENROGEN-10%",
      img: "/images/33.png",
      subTitle:
        "Enrofloxacin Oral Solution",
      composition: `
    - Enrofloxacin IP – 100 mg/ml
  `,
      productOverview: `
    ENROGEN-10% is a broad-spectrum fluoroquinolone antibiotic oral solution. It acts rapidly against a wide range of Gram-negative and Gram-positive bacteria as well as Mycoplasma species. It ensures high tissue penetration, rapid absorption, and effective bacterial clearance in poultry.
  `,
      indications: `
    - CRD (Chronic Respiratory Disease) due to Mycoplasma gallisepticum.
    - Colibacillosis, Salmonellosis, Pasteurellosis.
    - Fowl Cholera, Infectious Coryza.
    - Secondary bacterial infections in viral respiratory diseases.
    - Enteric infections caused by E. coli and other pathogens.
  `,
      benefits: `
    - Strong broad-spectrum antibacterial activity.
    - Rapid absorption with excellent bioavailability.
    - High concentration in respiratory & digestive tissues.
    - Fast recovery, improved flock performance, and reduced mortality.
  `,
      dosage: `
    Poultry (Broilers, Layers, Breeders):
    - 10 mg/kg body weight per day, equivalent to 1 ml per 5–10 kg body weight in drinking water, for 3–5 days.
    - Or as directed by a veterinarian.
  `,
      disclaimer:
        "The dosage and usage should be strictly as advised by a consultant veterinarian."
    },

    {
      id: 28,
      name: "TY-LEVO BH-20%",
      img: "/images/35.png",
      subTitle:
        "Tylosin Phosphate, Levofloxacin & Bromhexine Hydrochloride Oral Solution",
      composition: `
    - Tylosin Phosphate IP – 10 mg/ml
    - Levofloxacin – 100 mg/ml
    - Bromhexine Hydrochloride IP – 15 mg/ml
  `,
      productOverview: `
    TY-LEVO BH-20% is a broad-spectrum triple-action formulation combining a macrolide antibiotic (Tylosin), a fluoroquinolone antibiotic (Levofloxacin), and a mucolytic agent (Bromhexine).
    - Tylosin Phosphate: Highly effective against Mycoplasma and Gram-positive respiratory pathogens.
    - Levofloxacin: A broad-spectrum fluoroquinolone active against Gram-negative and Gram-positive bacteria.
    - Bromhexine Hydrochloride: Acts as a mucolytic, reduces viscosity of respiratory secretions, and enhances antibiotic penetration in lung tissue.
  `,
      indications: `
    - CRD (Chronic Respiratory Disease) due to Mycoplasma gallisepticum.
    - Complicated CRD (CCRD) with E. coli secondary infections.
    - Colibacillosis, Salmonellosis, Pasteurellosis.
    - Infectious Coryza & Fowl Cholera.
    - Respiratory distress in viral infections with secondary bacterial invasion.
  `,
      benefits: `
    - Triple-action synergy: Mycoplasma + Gram-negative + Gram-positive coverage.
    - Bromhexine ensures better antibiotic penetration into respiratory tissues.
    - Relieves respiratory congestion & mucus blockage.
    - Faster recovery, reduced mortality, and improved productivity.
    - Effective in both acute & chronic respiratory infections.
  `,
      dosage: `
    Poultry (Broilers, Layers, Breeders):
    - 1 ml per 10–15 kg body weight in drinking water, once daily for 3–5 days.
    - Or as directed by a veterinarian.
  `,
      disclaimer:
        "The dosage and usage should be strictly as advised by a consultant veterinarian."
    },


    {
      id: 29,
      name: "GENMULIN-LIQ (10%)",
      img: "/images/36.png",
      subTitle:
        "Tiamulin Hydrogen Fumarate 10% Oral Solution",
      composition: `
    - Tiamulin Hydrogen Fumarate – 100 mg/ml
  `,
      productOverview: `
    GENMULIN-LIQ (10%) is a highly effective pleuromutilin-class antibiotic oral solution designed for poultry.
    - Tiamulin is particularly effective against Mycoplasma species and other Gram-positive/anaerobic pathogens causing respiratory and enteric infections.
    - Offers excellent tissue penetration and rapid therapeutic action.
  `,
      indications: `
    - CRD (Chronic Respiratory Disease) caused by Mycoplasma gallisepticum & E. coli (as secondary infection).
    - Airsacculitis, Infectious Synovitis due to Mycoplasma synoviae.
    - Swine Dysentery & Enzootic Pneumonia (if extended to swine usage).
    - Control of respiratory & enteric infections sensitive to Tiamulin.
  `,
      benefits: `
    - Highly effective against Mycoplasma infections (first-line choice).
    - Good absorption and deep tissue penetration.
    - Rapid clinical response and improved flock performance.
    - Lower risk of cross-resistance with other antibiotic classes.
    - Improves livability and productivity under respiratory stress.
  `,
      dosage: `
    Poultry (Broilers, Layers, Breeders):
    - 15–20 mg per kg body weight daily (equivalent to 1 ml per 5–7 kg body weight) via drinking water, for 3–5 days.
    - Or as directed by a veterinarian.
  `,
      disclaimer:
        "The dosage and usage should be strictly as advised by a consultant veterinarian."
    },

    {
      id: 30,
      name: "CIPROGEN-Plus",
      img: "/images/37.png",
      subTitle:
        "Ciprofloxacin & Enrofloxacin Oral Solution",
      composition: `
    - Ciprofloxacin IP – 100 mg/ml
    - Enrofloxacin IP – 100 mg/ml
  `,
      productOverview: `
    CIPROGEN-Plus is a synergistic combination of two potent fluoroquinolones: Ciprofloxacin and Enrofloxacin.
    - Provides dual-action broad-spectrum antibacterial coverage.
    - Ensures rapid absorption and strong tissue penetration.
    - Highly effective against respiratory and enteric bacterial infections in poultry.
  `,
      indications: `
    - CRD (Chronic Respiratory Disease) due to Mycoplasma gallisepticum & E. coli.
    - Colibacillosis, Salmonellosis, Pasteurellosis, Fowl Cholera.
    - Enteritis & septicemia caused by Gram-negative bacteria.
    - Secondary bacterial infections during viral respiratory outbreaks.
    - Mixed infections requiring broad and potent coverage.
  `,
      benefits: `
    - Broad-spectrum synergy of Ciprofloxacin + Enrofloxacin.
    - Rapid action with excellent bioavailability.
    - Strong tissue penetration → effective in lungs, intestines, and systemic infections.
    - Faster recovery → improved flock health & performance.
    - Reduces mortality and enhances FCR (Feed Conversion Ratio).
  `,
      dosage: `
    Poultry (Broilers, Layers, Breeders):
    - 1 ml per 10–15 kg body weight in drinking water, once daily for 3–5 days.
    - Or as directed by a veterinarian.
  `,
      disclaimer:
        "The dosage and usage should be strictly as advised by a consultant veterinarian."
    },

    {
      id: 31,
      name: "CIPROGEN-10%",
      img: "/images/37.png",
      subTitle:
        "Ciprofloxacin Hcl Oral Solution",
      composition: `
    - Ciprofloxacin IP – 100 mg/ml
  `,
      productOverview: `
    CIPROGEN-10% is a broad-spectrum fluoroquinolone antibiotic oral solution.
    - Highly effective against Gram-negative, Gram-positive, and Mycoplasma infections.
    - Rapid absorption with deep tissue penetration.
    - Strong bactericidal activity for both respiratory and enteric diseases in poultry.
  `,
      indications: `
    - Chronic Respiratory Disease (CRD) caused by Mycoplasma gallisepticum & E. coli.
    - Colibacillosis, Salmonellosis, Pasteurellosis, Fowl Cholera.
    - Enteritis & septicemia due to E. coli and other pathogens.
    - Infectious Coryza and other bacterial respiratory infections.
    - Secondary bacterial complications during viral diseases.
  `,
      benefits: `
    - Broad-spectrum activity against Gram-positive, Gram-negative, and Mycoplasma.
    - Rapid action & high bioavailability.
    - Strong tissue penetration, especially in lungs & intestines.
    - Improves flock health, reduces mortality & enhances FCR.
    - Reliable solution for respiratory and enteric infections.
  `,
      dosage: `
    Poultry (Broilers, Layers, Breeders):
    - 10 mg/kg body weight daily, equivalent to 1 ml per 10 kg body weight, in drinking water for 3–5 days.
    - Or as directed by a veterinarian.
  `,
      disclaimer:
        "The dosage and usage should be strictly as advised by a consultant veterinarian."
    },

    {
      id: 32,
      name: "SULPHAGEN-Plus",
      img: "/images/39.png",
      subTitle:
        "Sulphamethoxazole & Trimethoprim Oral Solution",
      composition: `
    - Sulphamethoxazole IP – 100 mg/ml
    - Trimethoprim IP – 20 mg/ml
  `,
      productOverview: `
    SULPHAGEN-Plus is a synergistic combination of a sulfonamide (Sulphamethoxazole) and a dihydrofolate reductase inhibitor (Trimethoprim).
    - Acts via sequential blockade of folic acid metabolism in bacteria.
    - Produces strong bactericidal activity.
    - Highly effective against a wide range of bacterial infections in poultry.
  `,
      indications: `
    - Colibacillosis (E. coli infections).
    - Salmonellosis, Pasteurellosis, Fowl Cholera.
    - Coccidiosis (secondary bacterial complications).
    - CRD (Chronic Respiratory Disease) with secondary bacterial infections.
    - Enteritis, septicemia, and urinary tract infections.
  `,
      benefits: `
    - Broad-spectrum antibacterial action.
    - Synergistic combination → more effective than either drug alone.
    - High efficacy against both respiratory & enteric pathogens.
    - Improves flock performance by reducing morbidity & mortality.
    - Cost-effective solution for large-scale poultry treatment.
  `,
      dosage: `
    Poultry (Broilers, Layers, Breeders):
    - 1 ml per 5–10 kg body weight in drinking water daily, for 3–5 days.
    - Or as directed by a veterinarian.
  `,
      disclaimer:
        "The dosage and usage should be strictly as advised by a consultant veterinarian."
    }





  ],

  106: [
    {
      id: 33,
      name: "GENVIT-D3",
      img: "/images/40.jpeg",
      images: ["/images/40.jpeg", "/images/vitasol.jpg"],
      subTitle: "Vitamin D3 Poultry Feed Supplement",

      ProductOverview:
        "GENVIT-D3 is a highly concentrated Vitamin D3 and mineral supplement specially formulated for poultry. Vitamin D3 plays a vital role in calcium and phosphorus metabolism, ensuring proper bone development, eggshell formation, and improved overall performance. The fortified minerals provide additional nutritional support for stronger immunity, skeletal health, and productivity in both broilers and layers.",

      composition: `
    Each 1 gm contains:
    - Vitamin D3 (Cholecalciferol): 50,000 IU
    - Fortified minerals: Calcium, Phosphorus, Zinc, Manganese, Copper, Magnesium, Selenium
  `,

      features: `
    - Bone Health: Prevents rickets, leg weakness, and skeletal deformities.
    - Egg Production: Enhances eggshell strength, thickness, and quality.
    - Mineral Absorption: Improves calcium and phosphorus utilization.
    - Growth Performance: Supports weight gain and feed efficiency in broilers.
    - Immunity & Productivity: Strengthens natural resistance and reduces mortality.
    - Breeder Support: Improves fertility, hatchability, and chick quality.
  `,

      dosage: `
    - Broilers & Growers: 100–200 g per ton of feed.
    - Layers & Breeders: 150–300 g per ton of feed.
    - Or as advised by a poultry nutritionist/veterinarian.
  `,

      disclaimer:
        "Use as advised by a veterinarian. Store in a cool, dry place."
    },

    {
      id: 34,
      name: "IMMUNO PRO",
      img: "/images/41.jpeg",
      subTitle: "Research-based Unique Product for Better Immunity in Poultry",
      ProductOverview:
        "IMMUN PRO is a research-based unique formulation designed to strengthen the immune system and improve overall poultry health. It combines antioxidants, essential vitamins, probiotics, and bioactive peptides to enhance disease resistance, gut health, growth, and productivity",

      composition: `
    Each 1 Kg of IMMUNO PRO contains:
    - Vitamin E: 40 g
    - Selenium: 120 mg
    - Biotin: 380 mg
    - Bioactive Peptides: 25 mg
    - Natural Probiotic Strains: QS
  `,

      benefits: `
    - Boosts Immunity: Vitamin E and Selenium reduce oxidative stress and improve resistance against infections.
    - Gut Health Support: Probiotics balance intestinal microflora, aiding digestion and nutrient utilization.
    - Growth & Performance: Bioactive peptides promote protein synthesis and better feed efficiency.
    - Feather & Skin Care: Biotin improves feather quality and prevents dermatitis.
    - Stress Protection: Helps birds cope with stress from vaccination, climate changes, and high stocking density.
    - Flock Productivity: Reduces mortality and enhances livability.
  `,

      dosage: `
    - Layers & Broilers: 200–400 g per ton of feed.
    - Follow the advice of a veterinarian or poultry nutritionist for adjustments.
  `,

      disclaimer:
        "The dosage and usage should be as advised by the consultant veterinarian."
    },

    {
      id: 35,
      name: "LACTOGENE-PLUS",
      img: "/images/13.png",
      subTitle: "Specially Designed & Challenging Probiotic Formulation",
      images: ["/images/13.png", "/images/lactogen.png"],

      ProductOverview:
        "LACTOGEN-PLUS is a powerful multi-strain probiotic formulation designed to restore and maintain gut health in poultry and livestock. With a very high TVC count of carefully selected probiotic strains, it enhances digestion, nutrient absorption, immunity, and overall productivity, making it an ideal alternative to antibiotic growth promoters.",

      composition: `
    Each 1 kg contains:
    - Lactic acid bacillus: 12 × 10¹² CFU/g
    - Lactobacillus casei: 12 × 10¹² CFU/g
    - Lactobacillus acidilacti: 12 × 10¹² CFU/g
    - Lactobacillus delbrueckii: 12 × 10¹² CFU/g
    - Lactobacillus bulgaricus: 12 × 10¹² CFU/g
    - Lactobacillus acidophilus: 12 × 10¹² CFU/g
    - Lactobacillus salivarius: 12 × 10¹² CFU/g
    - Bacillus subtilis: 12 × 10¹² CFU/g
    - Bifidobacterium: 12 × 10¹² CFU/g
    - Pediococcus acidilacti: 9 × 10¹² CFU/g
    - Enterococcus faecium: 6 × 10¹² CFU/g
    - Saccharomyces boulardii: 250 mg
    - Fermented koji: QS
    - Carrier: QS
  `,

      features: `
    - Multi-strain, high CFU probiotic blend for maximum efficacy.
    - Improves gut flora balance and competitively excludes pathogens.
    - Enhances nutrient absorption, growth rate, and feed conversion ratio (FCR).
    - Reduces incidence of enteric infections, diarrhea, and dysbacteriosis.
    - Boosts natural immunity and stress tolerance.
    - Contains Saccharomyces boulardii and fermented koji for additional gut health support.
    - Reduces pathogenic bacterial load naturally and restores gut health.
    
   
  `,



      dosage: `
    - Poultry: 100 g of WSP per 1000 chicks.
    - Layers: 100 g of FSP per ton of feed.
    - Swine & Cattle: As directed by a veterinarian or nutritionist.
  `,

      disclaimer:
        "The dosage and usage should be as advised by a veterinarian."
    },





    {
      id: 36,
      name: "GUT-DAM",
      img: "/images/15.png",
      images: ["/images/15.png", "/images/gutdam.png"],
      subTitle: "Specially Designed & Challenging Probiotic Formulation",
      productOverview:
        "A scientifically developed powerful multi-strain probiotic blend for poultry, formulated to control and prevent loose droppings and abnormal litter conditions.",
      indications: `
    - For poultry flocks showing loose or colored droppings (yellow, red, green, foamy, whitish).
    - During periods of stress (vaccination, heat stress, antibiotic therapy, transportation).
    - To maintain gut health and performance in broilers, layers, and breeders.
  `,
      features: `
    - Contains a combination of bioactive peptides, natural ligands, probiotic strains, and biochemical molecules.
    - Helps control and prevent loose droppings and colored droppings (yellow, red, brown, green, foamy white) in poultry birds like broilers and layers.
    - Protects the gut of chicks from early-stage pathogenic microbial infections.
  `,
      benefits: `
    - Designed to stabilize intestinal microflora and restore gut balance.
    - Controls loose droppings and abnormal colored litter.
    - Reduces the risk of enteric infections and gut dysbiosis.
    - Improves feed conversion ratio (FCR) and weight gain.
    - Boosts natural immunity against disease challenges.
    - Safe, residue-free, and environmentally friendly.
    - Reduces mortality and improves flock uniformity.
  `,
      dosage: `
    - Poultry: 250 g – 300 g per 10,000 birds via water or feed.
    - Or as recommended by a nutritionist/veterinarian.
  `,
      disclaimer:
        "The dosage and usage should be as advised by a consultant veterinarian.",
    },




    {
      id: 37,
      name: "ELECTRO-GENE",
      img: "/images/12.png",
      subTitle: "Feed & Water Soluble – Immediate Release Electrolytes",
      ProductOverview:
        "ELECTROGENE is a fast-acting electrolyte formulation specially designed for poultry and livestock to maintain electrolyte balance, hydration, and energy levels during stress conditions. Its immediate-release action quickly restores lost electrolytes, reduces stress impact, and supports optimum health and productivity.",
      composition: `
    - Sodium Bicarbonate: 15 g
    - Sodium Chloride: 15 g
    - Potassium Chloride: 25 g
    - Sodium Acid Phospet: 2.5 g
    - Sodium Citrate: 30 g
    - Calcium Lactate: 10 g
    - Magnesium Sulphate: 5 g
    - Vitamin C: 12.5 g
    - Lacto Bacillus: 12.5 CFU
    - Selenium: 1 g
    - Glucose D: QS
  `,
      indications: `
    - To prevent and correct electrolyte imbalance & dehydration.
    - During heat stress, vaccination, transportation, or disease conditions.
    - For maintaining optimum growth, egg production, fertility, and hatchability.
    - Useful in broilers, layers, breeders, swine, and cattle.
  `,
      features: `
    - Provides a balanced blend of essential electrolytes (Na⁺, K⁺, Cl⁻, HCO₃⁻, Mg²⁺).
    - Ensures rapid absorption for quick recovery.
    - Maintains acid-base balance in the body.
    - Reduces the effects of heat stress, dehydration, and transport stress.
    - Can be administered through both feed and water.
  `,
      dosage: `
    - In Drinking Water: 1 g per liter of water (or as recommended).
    - In Feed: 500 g – 1 kg per ton of feed.
   
  `,
      disclaimer:
        "Veterinary feed supplement only. Not for medicinal or human use.",
    },

    {
      id: 38,
      name: "DI-GENE ",
      subTitle: "FCR Booster",
      img: "/images/42.jpeg",
      productOverview:
        "Highly Specific Active Furified Digestive Enzymes With Organic Acids and Buffering Agents ",
      composition: `
    - Purified Digestive Enzymes: Amylase, Protease, Lipase, Cellulase, Xylanase, Phytase (optimized blend)
    - Organic Acids: Formic, Butyric, Sorbic, Propionic, Lactic, Citric
    - Buffering Agents: Anhydrous Sodium Acetate, Monopotassium Phosphate, Stabilizers for gut pH balance
  `,
      features: `
    - Enhances digestion & nutrient utilization by breaking down complex carbohydrates, proteins & fats.
    - Promotes gut health – organic acids control harmful pathogens and improve gut microflora.
    - Maintains stable gut pH – buffering agents help avoid acidosis & improve feed efficiency.
    - Improves FCR (Feed Conversion Ratio) – supports better weight gain and productivity.
    - Prevents indigestion, loose droppings, and gut stress in poultry.
    - Boosts immunity & overall performance.
  `,
      indications: `
    - Poor digestion or feed conversion issues.
    - Gut stress due to high-density diets.
    - Loose droppings / wet litter conditions.
    - Growth retardation & reduced egg production.
  `,
      dosage: `
    - Poultry (Broilers / Layers / Breeders):
      • Feed: 250–500 g per ton of feed (or as recommended by nutritionist).
      • Water: 200–300 g per 100 liters of water during stress conditions.
  `,
      disclaimer:
        "The dosage and usage should be as advised by a veterinarian or nutritionist.",
    },


    {
      id: 39,
      name: "AMINO BOOSTER",
      img: "/images/43.jpeg",
      subTitle:
        "A protein supplement for poultry",
      composition: `
    - Essential Amino Acids:
      • Lysine: 1000 g
      • Methionine: 750 g
      • Threonine: 300 g
      • Tryptophan: 50 g
      • Valine: 30 g
    - Non-Essential Amino Acids:
      • Glycine, Glutamic acid, Serine, Alanine: 150 g
    - Plant-Derived Protein Hydrolysates: QS
    - Energy-Yielding Nutrients: QS
  `,
      features: `
    - Ensures balanced amino acid profile for muscle development.
    - Supplies high-quality protein for optimum growth & productivity.
    - Improves feed efficiency & weight gain.
    - Supports egg production & hatchability in layers and breeders.
    - Reduces chances of nutritional deficiencies & stress-related disorders.
    - Helps in faster recovery during illness or vaccination stress.
  `,
      indications: `
    - Protein deficiency & poor growth.
    - Reduced egg production or poor shell quality.
    - Stress conditions (heat, vaccination, disease challenges).
    - Recovery during/after illness.
  `,
      dosage: `
    - Broilers: 125–250 g per 100 kg feed (booster dose).
    - Layers & Breeders: 2.5 kg per ton of feed.
    - Or as recommended by a poultry nutritionist/veterinarian.
  `,
      disclaimer:
        "The dosage and usage should be as advised by a poultry nutritionist or veterinarian.",
    }
    ,


{
  id: 40,
  name: "GARLIGEN-15% (Garlic Extract)",

  img: "/images/60.png",

  subTitle:
    "Garlic Natural Herbal-Based Non-Antibiotic Growth Promoter",

  productOverview: `GARLIGEN-15% is a scientifically formulated herbal growth promoter enriched with high-potency garlic extract and standardized Allicin. It acts as a natural antimicrobial alternative to antibiotic growth promoters. GARLIGEN-15% strengthens immunity, supports gut health, and improves feed conversion efficiency across poultry, livestock, and aqua species.`,

  composition: `
  - Garlic Extract: 15%
  - Allicin (Active Ingredient): 1.5%
  - Carrier Base: Q.S.
  `,

  features: `
  HOW GARLIGEN-15% WORKS
  - Allicin provides strong antibacterial, antifungal, and antiviral action.
  - Suppresses harmful gut pathogens (E. coli, Salmonella, Clostridium).
  - Improves digestion by stimulating natural enzyme activity.
  - Enhances blood circulation and metabolic efficiency.
  - Reduces bacterial load and pathogenic stress.
  - Strong antioxidant: Neutralizes free radicals, reducing oxidative stress.
  - Enhances disease resistance and vaccine response.
  `,

  benefits: `
  Poultry:
  - Improves FCR, body weight gain, and uniformity.
  - Reduces E. coli, Salmonella, and Clostridium pressure.
  - Controls wet droppings and reduces ammonia levels.
  - Boosts respiratory health and natural immunity.

  Livestock:
  - Enhances rumen function and feed digestion.
  - Supports milk yield and overall animal vigor.

  Aqua:
  - Reduces bacterial load in the gut.
  - Improves survival rate and growth conversion.
  `,

  dosage: `
  Poultry:
  - Broilers / Layers / Breeders: 200–500 g per metric ton of feed.
  - During stress / disease challenge: 500–1,000 g per MT feed.

  Livestock:
  - 10–20 g per 100 kg body weight per day (through feed).

  Aqua:
  - 1–2 kg per ton of feed.
  - Stress period: 2–3 kg per ton.
  `,

  disclaimer:
    "Dosage may vary based on field conditions. Usage should be as advised by a poultry nutritionist or veterinarian.",
}


  ],
  107: [
    {
      id: 41,
      name: "PHYTOACT",
      img: "/images/5.png",
      subTitle: "Phytase Enzyme – 5000 FTU/gm",
      ProductOverview:
        "PHYTOACT is a highly concentrated phytase enzyme (5000 FTU/gm) specially designed for poultry and livestock nutrition. It improves the bioavailability of phosphorus, calcium, and other essential nutrients bound in phytate, thereby enhancing growth performance, reducing feed costs, and minimizing environmental phosphorus excretion.",
      composition: `
    - Active Ingredient: Phytase Enzyme – 5000 FTU/gm
  `,
      features: `
    - High-activity phytase – 5000 FTU/gm for efficient phytate degradation.
    - Enhances phosphorus, calcium, zinc, and amino acid availability.
    - Reduces dependency on costly inorganic phosphorus supplements (e.g., DCP/MCP).
    - Improves feed conversion ratio (FCR) and body weight gain.
    - Environment-friendly – lowers phosphorus excretion in litter and manure.
    - Stable during feed processing and pelleting.
  `,
      benefits: `
    - For improving growth performance in broilers, layers, breeders, and swine.
    - To maximize nutrient utilization in corn-soya diets.
    - To reduce feed cost by lowering inclusion of inorganic phosphorus sources.
    - Enhances mineral and amino acid absorption.
  `,
      dosage: `
    - Poultry & Swine: 100–200 g per ton of feed (or as recommended by nutritionist).
    (Dosage may vary depending on diet formulation and nutrient requirements.)
  `,
      disclaimer:
        "The dosage and usage should be advised by the consultant veterinarian."
    }
    ,

    {
      id: 42,
      name: "MULTIGENE",
      img: "/images/6.png",
      subTitle: "Multi-Enzyme Feed Supplement",
      productOverview:
        "MULTIGENE is a broad-spectrum multi-enzyme formulation designed to improve nutrient digestibility, feed efficiency, and animal performance. By breaking down complex feed components such as starch, fiber, protein, and phytates, it enhances nutrient release and supports optimal growth in poultry and livestock.",
      KeyEnzymes: `
    - Amylase – Breaks down starch into digestible sugars for better energy utilization.
    - Protease – Improves protein digestion and amino acid absorption.
    - Cellulase – Degrades cellulose and fiber for improved feed utilization.
    - Xylanase – Breaks down arabinoxylans, reduces digesta viscosity, enhances gut health.
    - β-Glucanase – Improves nutrient release by hydrolyzing β-glucans.
    - Lipase – Aids in digestion of dietary fats and oils.
  `,
      features: `
    - Complete enzyme spectrum for maximum nutrient release.
    - Enhances nutrient absorption (protein, energy, minerals).
    - Improves feed conversion ratio (FCR) and growth performance.
    - Reduces dependence on costly feed ingredients.
    - Enhances gut health and digestion.
    - Minimizes nutrient wastage and reduces environmental load.
    - Stable during feed pelleting and storage.
  `,
      dosage: `
    - Poultry: 500 g – 1 kg per ton of feed (depending on diet composition).
    - Swine & Cattle: As per nutritionist recommendation.
  `,
      disclaimer:
        "The dosage and usage should be advised by the consultant veterinarian."
    },

    {
      id: 43,
      name: "GENE-PROTEASE",
      subTitle: "Protease Enzyme Supplement",
      img: "/images/45.jpeg",
      productOverview:
        "A highly efficient protease enzyme formulation designed to enhance protein digestion and amino acid utilization in poultry and livestock. Improves feed efficiency, growth performance, and overall profitability.",
      composition: `
    - Active Ingredient: Protease Enzyme (high activity)
  `,
      modeOfAction: `
    - Breaks down dietary and indigestible proteins in corn–soy and other plant-based feed.
    - Increases release of essential amino acids for better muscle development and performance.
    - Reduces excretion of undigested protein, lowering environmental nitrogen load.
  `,
      features: `
    - Hydrolyzes complex protein structures into simple, digestible forms.
    - Improves amino acid absorption and reduces nitrogen wastage.
    - Enhances feed conversion ratio (FCR) and growth rate.
    - Stable during feed pelleting and processing.
    - Reduces anti-nutritional effects of protein-bound components.
  `,
      benefits: `
    - For improving protein digestibility in broilers, layers, breeders, swine, and aqua species.
    -To optimize utilization of soybean meal, fish meal, and other protein sources.
-To reduce dependence on costly digestible protein supplements.
-	Enhances body weight gain & productivity.
-	Boosts profitability for farmers.

  `,
      dosage: `
    - 	Poultry: 50–100 g per ton of feed.
- Swine & Aqua: As per nutritionist/veterinarian recommendation.

  `,
      disclaimer:
        "The dosage and usage should be as advised by the consultant veterinarian."
    }
    ,
    {
      id: 44,
      name: "GENE-LIPASE",
      subTitle: "Lipase Enzyme Supplement",
      img: "/images/46.jpeg",
      productOverview:
        "GENE-LIPASE  high-activity lipase enzyme formulation designed to improve the digestion and utilization of dietary fats and oils in poultry, swine, and aqua species. Enhances energy availability, growth performance, and feed efficiency.",
 
      modeOfAction: `
    - Breaks down triglycerides into easily absorbable free fatty acids and glycerol.
    - Enhances energy supply for maintenance, growth, and reproduction.
    - Reduces undigested fat excretion, improving gut health and lowering feed cost.
  `,
      features: `
    - Efficiently hydrolyzes dietary fats and oils for better energy release.
    - Improves utilization of low-quality fats and by-products in feed.
    - Enhances feed conversion ratio (FCR) and growth rate.
    - Stable under feed processing and pelleting conditions.
    - Reduces variability in fat digestion among animals, especially young chicks and piglets.
  `,
      benefits: `
    - Improves fat digestion in poultry, swine, ruminants, and aqua species.
    - Optimizes utilization of vegetable oils, animal fats, and blended by-product fats.
    - Useful in young animals with low natural lipase secretion.
    - Improves absorption of fats, oils, and fat-soluble vitamins (A, D, E, K).
    - Reduces feed cost by maximizing energy efficiency.
    - Increases overall profitability in farming. 
  `,
      dosage: `
    - Poultry: 100–200 g per ton of feed.
    - Swine & Aqua: As per nutritionist recommendation. As directed by veterinarian.
  `,
      disclaimer:
        "The dosage and usage should be as advised by the consultant veterinarian."
    }
  ],

};
